import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { WifiSlashIcon } from '@phosphor-icons/react'

import { useAuth } from './AuthProvider'

/**
 * Shown on protected routes when the auth check could not reach the API
 * (restart, deploy, network blip). The session may be perfectly valid, so
 * this is a reconnecting state, never a sign-out. AuthProvider keeps
 * re-checking in the background and the page renders as soon as it answers.
 */
export function AuthConnectionRetry() {
  const { checkUserAuth } = useAuth()
  const [isRetrying, setIsRetrying] = useState(false)

  const handleRetry = async () => {
    setIsRetrying(true)
    try {
      await checkUserAuth({ force: true, debounceMs: 0 })
    } finally {
      setIsRetrying(false)
    }
  }

  return (
    <div
      role="status"
      className="flex min-h-[var(--tauri-content-height,100vh)] w-full items-center justify-center bg-background p-6"
    >
      <div className="flex max-w-sm flex-col items-center gap-3 text-center">
        <WifiSlashIcon
          aria-hidden
          className="size-8 text-muted-foreground/70"
        />
        <h1 className="text-base font-medium text-foreground">
          Can&apos;t reach Scrambl
        </h1>
        <p className="text-sm text-muted-foreground">
          We&apos;ll keep trying and pick up right where you left off.
        </p>
        <Button
          variant="outline"
          size="sm"
          onClick={handleRetry}
          disabled={isRetrying}
        >
          {isRetrying ? 'Trying…' : 'Try again'}
        </Button>
      </div>
    </div>
  )
}
